import * as Yup from "yup";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// form
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import { Box, Grid, Card, Stack, InputAdornment } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "src/components/snackbar";
import { useAuthContext } from "src/auth/useAuthContext";

// components
import FormProvider, { RHFTextField } from "../../../components/hook-form";
import { PATH_DASHBOARD } from "../../../routes/paths";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const CountryCode = process.env.REACT_APP_COUNTRY_CODE;

// ----------------------------------------------------------------------

export default function CustomerGeneralInfo({ customer }) {
  const [dob, setDOB] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const UpdateUserSchema = Yup.object().shape({
    phone: Yup.string().matches(
      /^\d{10}$/,
      "Phone number must be exactly 10 digits"
    ),
     email: Yup.string()
      .email("Invalid email format")
  });

  const defaultValues = {
    firstName: customer?.firstName || "",
    lastName: customer?.lastName || "",
    phone: customer?.phone || "",
    email: customer?.email || "",
    area: customer?.address?.area || "",
    street: customer?.address?.street || "",
    city: customer?.address?.city || "",
  };

  const methods = useForm({
    resolver: yupResolver(UpdateUserSchema),
    defaultValues,
  });

  const {
    reset,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (customer) {
      reset({
        firstName: customer.firstName || "",
        lastName: customer.lastName || "",
        phone: customer.phone || "",
        email: customer.email || "",
        area: customer.address?.area || "",
        street: customer.address?.street || "",
        city: customer.address?.city || "",
      });
    }
  }, [customer, reset]);

  const onSubmit = async (data) => {
    try {
      const getToken = sessionStorage.getItem("accessToken");
      const { email, phone, firstName, lastName, area, street, city } = data;

      const payload = {
        // name,
        firstName: firstName,
        lastName: lastName,
        phone,
        email,
        address: {
          area,
          street,
          city,
        },
        venueId: user.venue.id,
      };

      // if (email?.trim()) {
      //   payload.email = email;
      // }

      const response = await axios.patch(
        `${backendUrl}/venueCustomer/${customer.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );

      enqueueSnackbar("Update success!");
      navigate(PATH_DASHBOARD.customer.list);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid>
        <Grid item xs={12} md={9}>
          <Card sx={{ p: 3 }}>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
              }}
            >
              <RHFTextField name="firstName" label="First Name" />
              <RHFTextField name="lastName" label="Last Name" />

              <RHFTextField
                name="phone"
                label="Phone Number"
                placeholder="3xxxxxxxxx"
                disabled
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <span>{CountryCode}</span>
                    </InputAdornment>
                  ),
                  inputMode: "numeric",
                }}
              />

              <RHFTextField name="email" label="Email Address" />

              <RHFTextField name="street" label="House/Street" />
              <RHFTextField name="area" label="Area" />
              <RHFTextField name="city" label="City" />
            </Box>

            <Stack spacing={3} alignItems="flex-end" sx={{ mt: 3 }}>
              <LoadingButton
                type="submit"
                variant="contained"
                loading={isSubmitting}
              >
                Update
              </LoadingButton>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
